import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { FaSearch } from "react-icons/fa";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";
import Button from "../../../Buttons/Button";
import { ButtonIcon } from "./TableSettingsComponents";

const SearchWrapper = styled.div`
  display: inline-block;
  float: right;
  height: 38px;
  box-sizing: border-box;

  div {
    height: 100%;
  }

  .MuiInputBase-root {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: white;
  }

  button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-right: 0 !important;
    height: 38px;
  }
`;

interface SearchBarProps {
  onSearch: (text: string) => void;
  initialValue?: string;
}

export const SearchBar: React.FC<SearchBarProps> = (props) => {
  const { onSearch, initialValue = "" } = props;
  const theme = useTheme();
  const [searchText, setSearchText] = useState<string>(initialValue);

  useEffect(() => {
    setSearchText(initialValue);
  }, [initialValue]);

  const styles = {
    display: "inline-flex",
    borderRadius: "0 0.7rem 0.7rem 0",
    background: "transparent",
    borderColor: theme.palette.primary.dark,
    borderLeft: 0,
    borderWidth: "1px",
    color: theme.palette.primary.dark,
  };

  return (
    <SearchWrapper>
      <TextField
        id="outlined-basic"
        variant="outlined"
        size="small"
        onChange={(event) => setSearchText(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            onSearch(searchText);
          }
        }}
        value={searchText}
      />
      <Button onClick={() => onSearch(searchText)} style={styles}>
        <ButtonIcon>
          <FaSearch />
        </ButtonIcon>
        Search
      </Button>
    </SearchWrapper>
  );
};
